import van from "vanjs-core";

const {div, span} = van.tags;


// Big tag s big textem v contentu
export const BigTag = (descriptionCs, descriptionEn, stateVar, unit, green=false, fitContent=false, multiLine=false, additionalClass) => {
    const tagClass = `pl-tag big-tag-padding big-tag-border ${green ? "bg-green" : "bg-blue"} ${fitContent ? "wf" : ""} ${multiLine ? "column-tag" : ""} ${additionalClass}`;
    const tagTextClass = `big-tag-text ${green ? "text-dark-blue" : "text-light-blue"}`;

    return [
        div({class: "mobile-spacer"}),
        div(
            span({class: "big-text text-dark-blue"}, () => stateVar.val),
            span({class: "unit-text ms-2 text-dark-blue"}, typeof unit === 'string' ? unit : () => unit.val),
        ),
        div({class: tagClass},
            span({class: "text-white me-2 big-tag-text"}, descriptionEn),
            multiLine ? div({class: "sm-hide spacer"}) : null,
            span({class: tagTextClass}, descriptionCs),
        )
    ];
};